<template>
  <div class="w_100">
	<AgItem
	  class="track_detail_table"
	  :rowData="rowData"
	  suppressRowClickSelection="false"
	  rowSelection="single"
	  @row-select="onRowSelect"
	  :columnDefs="columnDefs"
	  v-on:sortChanged="sortChanged"
	  :with-header="true"
	></AgItem>
  </div>
</template>

<script>
import AgItem from "src/components/templates/agGrid/AgItem.vue";
import PaginationParent from "src/components/templates/common/PaginationParent.vue";

export default {
  extends: PaginationParent,
  components: {
    AgItem,
  },
	props: {
		rowData: Array,
	},
  data() {
    return {
      columnDefs: [],
      gridApi: null,
      filters: [],
      sorting: []
    };
  },
  created() {
    this.rowData = [];
    this.setColumnDefs();
    this.getList();
  },
	methods: {
    sortChanged(sortData) {
      this.sorting = sortData;
      this.initPage();
      this.getList();
    },
    getGridApi(gApi) {
      this.gridApi = gApi;
    },
    setColumnDefs() {
      this.columnDefs = [
        {
          headerName: this.$t("trackPay.trackProgressModal.deviceID"),
          field: "shipmentUnitId",
          minWidth: 350,
          sortable: true,
        },
        {
          headerName: this.$t("trackPay.trackProgressModal.lastUpdated"),
          field: "lastUpdated",
          minWidth: 130,
          sortable: true,
        },
        // not deleted since it will be needed in the future
        // {
        //   headerName: this.$t("trackPay.trackersForm.location"),
        //   field: "isLocation",
        //   minWidth: 100,
        //   cellRendererFramework: "TrackDeviceMark",
        //   sortable: true,
        //   cellRendererParams: {
        //     markConfig: {
        //       showPopover: false,
        //     },
        //   },
        // },
        // {
        //   headerName: this.$t("trackPay.trackersForm.shock"),
        //   field: "isShock",
        //   sortable: true,
        //   cellRendererFramework: "TrackDeviceMark",
        //   minWidth: 80,
        //   cellRendererParams: {
        //     markConfig: {
        //       showPopover: true,
        //       unit: "g",
        //       min: 0,
        //       max: 20,
        //     },
        //   },
        // },
        // {
        //   headerName: this.$t("trackPay.trackersForm.temperature"),
        //   field: "isTemperature",
        //   sortable: true,
        //   cellRendererFramework: "TrackDeviceMark",
        //   minWidth: 120,
        //   cellRendererParams: {
        //     markConfig: {
        //       showPopover: true,
        //       unit: "°C",
        //       min: -40,
        //       max: 40,
        //     },
        //   },
        // },
        // {
        //   headerName: this.$t("trackPay.trackProgressModal.airPressure"),
        //   field: "isAirpressure",
        //   sortable: true,
        //   cellRendererFramework: "TrackDeviceMark",
        //   minWidth: 120,
        //   cellRendererParams: {
        //     markConfig: {
        //       showPopover: true,
        //       unit: "hPA",
        //       min: 900,
        //       max: 3000,
        //     },
        //   },
        // },
        // {
        //   headerName: this.$t("trackPay.trackProgressModal.humidity"),
        //   field: "isHumidity",
        //   sortable: true,
        //   cellRendererFramework: "TrackDeviceMark",
        //   minWidth: 80,
        //   cellRendererParams: {
        //     markConfig: {
        //       showPopover: true,
        //       unit: "%",
        //       min: 0,
        //       max: 80,
        //     },
        //   },
        // },
      ];
    },
    getList() {
      let postData = {
        columns: [],
        filters: [],
        maxResults: this.maxResults,
        offset: this.offset,
        sorting: this.sorting,
      };
    },
    onRowSelect(params) {
		if (params && params.node && params.node.isSelected()) {
			this.$emit("changeUnit", params.data);
		}
    }
  }
};
</script>
<style lang="scss">
.track_detail_table {
  .ag_table {
    height: 200px !important;
    min-height: 200px !important;
  }
}
</style>
